import type { ApiClient } from '../../@sprinx/react-after-razzle';

export type ContactSupervisorsParams = Pick<ContactTotalOrderLimit, 'contactId' | 'supervisorId' | 'totalOrderLimit'>;

export type ContactTotalOrderLimit = {
  contactId: string;
  id: string;
  supervisorId: string;
  totalOrderLimit: number;
  type: string;
};

export async function getContactTotalOrderLimit(
  apiClient: ApiClient,
  contactId: string,
): Promise<ContactTotalOrderLimit | null> {
  return apiClient.get<ContactTotalOrderLimit | null, {}>('/v1/documents/contact-total-order-limit', { contactId });
}

export async function upsertContactTotalOrderLimit(
  apiClient: ApiClient,
  data: ContactSupervisorsParams,
): Promise<ContactTotalOrderLimit> {
  return apiClient.post<ContactTotalOrderLimit, {}>('/v1/documents/upsert-contact-total-order-limit', data);
}

export async function removeContactTotalOrderLimit(apiClient: ApiClient, contactId: string): Promise<void> {
  return apiClient.delete<void, {}>('/v1/documents/remove-contact-total-order-limit', { contactId });
}
